import axios from 'axios'
import type { userRole } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'role'


export const readRoleListAPI = async () => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
    },
  })
  console.log("readRoleListAPI 응답:", response.data)
  return response.data.data
}

export const addRoleAPI = async (name : string, permissions: userRole, description: string) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      name: name,
      permissions: btoa(JSON.stringify(permissions)),
      description: description
    },
  })
  console.log("addRoleAPI 응답:", response.data)
  return response.data.data
}

export const updateRoleAPI = async (id: number, name : string, permissions: userRole, description: string) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      id: id,
      name: name,
      permissions: btoa(JSON.stringify(permissions)),
      description: description
    },
  })
  console.log("updateRoleAPI 응답:", response.data)
  return response.data.data
}

export const deleteRoleAPI = async (id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id
    },
  })
  console.log("deleteRoleAPI 응답:", response.data)
  return response.data.data
}